import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LocalStorageService } from '../localStorage-service/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserLanguageService {
  lang$ = new BehaviorSubject(null);
  labels$ = new BehaviorSubject(null);

  constructor(private localStorageService: LocalStorageService) { }

  getLanguage(): Observable<String> {
    this.lang$.pipe(
      switchMap(lang => {
        const language = this.localStorageService.getItem('lang') || "cirilica"
        if (language) {
          return language
        }

        return of(null)
      })
    ).subscribe((err) => console.log(err))

    return this.lang$
  }

  setLanguage(lang) {
    this.localStorageService.setItem('lang', lang);
    this.lang$.next(lang);
    if (this.lang$.value == "eng") {
      this.labels$.next(this.labelsEng);
    } /*else if(this.lang$.value == "srb") {
      this.labels$.next(this.labelsSrb);
    }*/ else {
      this.labels$.next(this.labelsSrb2);
    }
  }

  getLabels() {
    this.lang$.next(this.localStorageService.getItem('lang'))
    if (this.lang$.value == "eng") {
      this.labels$.next(this.labelsEng);
    } /*else if(this.lang$.value == "srb") {
      this.labels$.next(this.labelsSrb);
    }*/ else {
      this.labels$.next(this.labelsSrb2);
    }
    this.labels$.pipe(
      switchMap(labels => {
        if (labels) {
          return of(labels)
        }
      })
    ).subscribe((err) => console.log(err))

    return this.labels$
  }

  labelsSrb = {
    //userd-dashboard-content
    lblTraining: "Oblasti",
    lblUnderConstruction: "Ova stranica je u izradi",
    lblHomeMessageEMS: "Dobrodošli na EMS platformu za elektronsku edukaciju",
    lblHomeMessage: "Dobrodošli na platformu za elektronsku edukaciju",
    lblShowAll: "Vidi sve oblasti",
    lblYes: "Da",
    lblNoButton: "Ne",
    lblTrainingNotStarted: "Započnite",
    lblTrainingStarted: "Nastavite",
    lblTrainingFinished: "Pogledaj",
    lblTrainingFinishedPopup: "Završili ste ovu oblast",
    //user-profile
    lblMyCourses: "Moji kursevi",
    lblEdit: "Izmeni",
    lblFinished: "završeno",
    lblStarted: "Yapočeta",
    lblStart: "Započnite",
    lblNotStarted: "Nije započeto",
    lblDateOfBirth: "datum rođenja",
    lblInfo: "Info",
    lblContinue: "Nastavite",
    lblContinueUnit: "Nastavite",
    lblContinueTraining: "Nastavite na sledeću oblast",
    lblGoBackAfterTraining: "Vratite se na početnu stranu klikom na dugme",
    lblSelectedImage: "Izabrana slika",
    lblDelPicture: "Obriši profilnu sliku",
    lblDeleteThisUsersProfilePicture: "Da li ste sigurni da želite da obrišete profilnu sliku?",
    lblAreYouSureSurvey: "Za uspešan završetak oblasti neophodno je uraditi zadatak.",
    lblGiveUpSurvey: "Odustanite od zadatka",
    lblAreYouSureSurvey2: "Ukoliko izađete iz zadatka, bićete u obavezi da ponovo preslušate kompletan materijal iz ove oblasti.",
    lblDelEvent: "Obriši događaj",
    lblDeleteThisEvent: "Da li ste sigurni da želite da obrišete događaj?",
    lblDelete: "Obrisi",
    lblNo: "Ne, hvala",
    lblHelp: "Pomoć",
    lblNoDocuments: "Dokumenti su dostupni na stranici za podršku korisnicima KISS na intranetu RGZ-a",
    lblDocument: "Dokument",

    //main-header
    lblSerbian: "Srpski",
    lblSerbianCyrillic: "Српски",
    lblEnglish: "English",
    lblLogOut: "Odjavi se",
    lblChangeLang: "Promeni jezik",

    //training-details
    lblDuration: "Trajanje",
    lblOverview: "Pregled",
    lblDocuments: "Dokumenta",
    lblInstructor: "Trener",
    lblComments: "Komentari",
    lblDownload: "Preuzmi",
    downloadBeforeProceeding: "Preuzmite dokument kako biste nastavili na sledeću lekciju.",
    lblTestResults: "Rezultati testa",
    lblSurveyResults: "Rezultati zadatka",
    lblCertificate: "Sertifikat",
    lblStudents: "studenata",
    lblCourses: "kurseva",
    lblEmail: "E pošta",
    lblPersonResponsible: "Odgovorna osoba",
    lblSections: "Oblasti",
    lblStatus: "Status",
    lblProgress: "Progres",
    lblViewed: "pogledano",
    lblNumOfUnits: "Lekcije",
    lblNoUnits: "Trenutno ne postoje lekcije za ovu oblast.",
    lblNumOfSections: "oblasti",
    lblduration: "trajanje",

    //login
    lblRedirection: "Ova stranica vas preusmerava na RGZ platformu za verifikaciju. Ukoliko niste automatski preusmereni, molimo da kliknete na ",
    lblLanguage: "Jezik",
    lblLogin: "PRIJAVA",
    lblWelcomeMessage: "Dobrodošli na platformu za edukaciju zaposlenih u Republičkom geodetskom zavodu",
    lblPassword: "Lozinka",
    lblForgotPassEmail: "Unesite vašu mejl adresu za resetovanje lozinke",
    lblForgotPass: "Zaboravljena lozinka",
    lblPasswordChanged: "Uspešno ste promenili lozinku, sada se možete prijaviti.",
    lblExpiredLink: "Link za resetovanje lozinke je istekao, molimo Vas da ponovo zatražite resetovanje lozinke.",
    lblPasswordResetLinkSent: "Link za resetovanje lozinke je poslat na Vašu e-mail adresu.",
    lblSingIn: "Uloguj se",
    loginGoogle: "Prijavite se preko Google naloga",
    loginFacebook: "Prijavite se preko Facebook naloga",
    lblDontHaveAccount: "Nemate nalog?",
    lblPassRequired: "Lozinka je obavezna.",
    lblEmailRequired: "Email je obavezan.",
    lblGender: "Pol",
    lblMaleGender: "Muški",
    lblFemaleGender: "Ženski",
    lblEducation: "Obrazovanje",
    lblPrimaryEducation: "Osnovno obrazovanje",
    lblSecondaryEducation: "Srednje obrazovanje",
    lblHigherEducation: "Visoko obrazovanje",
    //registracija
    lblSignUp: "Registrujte se",
    lblSignUpWrongDataMessage: "Uneli ste nevažeće podatke, proverite ponovo formu ili kontaktirajte podršku.",
    lblSupport: "Podrška",
    lblContactSupport: "Kontaktirajte podršku",
    lblSignUpUserAlreadyExists: "Korisnik sa ovim korisničkim imenom/e-mejlom već postoji, molimo da resetujete lozinku ukoliko ste je zaboravili",
    lblInvalidEmail: "Neispravan e-mail",
    lblJMBGAlreadyExists: "Korisnik sa unetim JMBG već postoji",
    lblCaptchaFailed: "Captcha nije prošla, molimo da učitate ponovo stranicu.",
    lblSignUpMessage: "Poštovani, uspešno ste se registrovali. Proverite Vaš e-mail kako biste se prijavili na platformu.",
    lblJmbg: "Matični broj (JMBG)",
    lblPhoneNumber: "Broj telefona",
    lblExpiredUser: "Poštovani, poštovana, Vaš rok za završetak obuke je istekao. Za dalje korake, kontaktirajte sektor za DT.",
    lblCity: "Grad",

    lblEnterEmail: "Ukoliko želite da resetujete lozinku u polje upišite e-mail adresu",
    lblSend: "Pošalji",
    lblAcceptTerms: "Da biste nastavili morate da prihvatite uslove korišćenja",
    lblAllFieldsCorrect: "Izjavljujem da su svi uneti podaci ispravni",
    //edit-profile
    lblUserName: "Korisničko ime",
    lblFirstName: "Ime",
    lblLastName: "Prezime",
    lblNewPassword: "Nova lozinka",
    lblEnterNewPassword: "Unesite novu lozinku",
    lblConfirmPassword: "Potvrdi novu lozinku",
    lblSave: "Sačuvaj",

    //test
    lblNext: "Nastavite",
    lblBack: "Nazad",
    lblBackToTraining: "Nazad na oblast",
    lblBackToTask: "Nazad na zadatak",
    lblBackToBeginning: "Vratite se na početak",
    lblGoToNextTraining: "Nastavite na sledeću oblast",
    lblSubmit: "Potvrdi",
    lblQuestionsCompleted: "završeno",
    lblStartQuiz: "Započnite test",
    //before-pre-test modal
    lblTestInFront: "Pred vama je pre-test kojim merimo",
    lblYourKnowledge: "vaše znanje pre oblasti.",
    lblTotalOf: " Imate ukupno",
    lblQuestions: "pitanja.",
    lblMaxPoints: "Maksimalan broj bodova je",
    lblGoodLuck: "Srećno!",
    lblIfAnsweredIncorrectly: "Ukoliko netačno odgovorite na neko od pitanja bićete u obavezi da ponovo preslušate kompletan materijal iz ove oblasti.",
    lblTimeIsUp: "Vreme je isteklo!",

    //pre-test modal
    lblYourSuccesRate: "Vaš procenat je",
    lblWatchAgain: 'Pogledajte saržaj ove oblasti ponovo i pristupite testu.',
    lblYouAnswered: "Odgovorili ste tačno na",
    lblOf: "od",
    lblYouHaveWon: "Osvojili ste ukupno",
    lblPoints: "poena",
    lblPointsWithA: "poen",

    //before test modal
    lblTestInFront1: "Pred vama je test za proveru znanja.",
    forPassingTheTest: "Za uspešno polaganje testa",
    forPassingTheSetionTest: "Za uspešno polaganje testa",
    lblMinPoints: "Neophodno je da odgovorite tačno na",
    lblOfferedQuestions: "od ponuđenih pitanja.",

    //test modal
    lblYouPassed: "POLOŽILI STE!",
    lblYoudDidntPassed: "NISTE POLOŽILI!",
    lblYoudDidntPassedTable: "Niste položili",
    lblCongrats: "Čestitamo položili ste test za oblast",
    lblSectionCongrats: "Čestitamo položili ste test za oblast",
    lblUnsuccessfulTestMessage: "Morate ponovo da prođete osnovnu oblast, o čijem datumu ćete biti blagovremeno obavešteni.",
    lblHomePage: "Početna",
    lblTryAgain: "Pokušaj ponovo",

    //before survey modal
    lblSurveyIsContained: "Pred Vama je zadatak koji je potrebno uraditi da biste uspešno završili oblast.",
    lblSurveyIsContainedPlural: "Pred Vama su zadaci koje je potrebno uraditi da biste uspešno završili oblast.",
    lblYourOpinion: "Vaše mišljenje nam je veoma važno",
    lblInOrderToKnow: "kako bi znali na koji način ",
    lblToImprove: "da unapredimo Vaše iskustvo na platformi",

    // survey modal
    lblThankYouforFilling: "Čestitamo položili ste oblast",
    lblTypeYourAnswerHere: "Unesite broj predmeta",
    lblKlikomNaDugme: "Klikom na dugme \"zadatak\" možete preuzeti popunjeni zadatak",
    lblThankYou: "HVALA!",
    lblSurvey:"Zadatak",
    lblPreTest: "Pretest",
    lblTest: "Test",
    lblTestTable: "Status provere",

    //training
    lblCompleted: "odgledano",
    backBtnPath: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/nazad%20dugme.png?alt=media&token=e6b34c1c-ae19-4628-a605-234942a31646",
    backBtnPath1: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/Nazad%20dugme%20latinica.png?alt=media&token=467523e2-b56b-45c4-8d76-2213f4d5dad9",
    playButton: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/Srp%20peach%20button.png?alt=media&token=58abea34-271a-467c-81ae-7ea0717cf0dc",

    //training modal
    lblNotification: "Obaveštenje",

    lblModalMessage: "Da biste prešli na sledeću lekciju, prethodnu lekciju morate pogledati do kraja.",
    lblModalMessageDocument: "Morate da preuzmete dokument, kako biste nastavili na sledeću lekciju.",

    lblWrongLoginData: "Pogrešno ste uneli korisničko ime ili lozinku.",
    lblUnverifiedEmail: "Vaša e-mail adresa nije verifikovana. Molimo vas da proverite vaš e-mail.",

    lblSeveralCorrectAnswers: "Ovo pitanje ima više tačnih odgovora.",
    lblQuestionPoints: "Pitanje nosi",
    lblOk: "U redu",
    lblDashboard: "Početna strana",
    lblUserProfile: "Profil",
    lblStatement: "Izjava",

    //messages
    lblMessages: "Poruke",
    lblWriteAMessage: "Napišite poruku...",
    lblYou: "Vi: ",
    lblSectorGroup: "Sektor grupa",

    //notifications
    lblNotifications: "Obaveštenja",
    lblDeleteAll: "Obriši sve",
    lblNoNotifications: "Nemate nijedno obaveštenje",

    //user cards
    lblComment: "Napišite komentar...",

    //welcome
    lblWelcome: "Dobrodošli na elektronsku oblast",
    lblWelcomeTest: "Dobrodošli na test",

    lblDataChanged: "Uspešno ste izmenili podatke.",
    lblUserDocuments: "Korisnička dokumenta",

    lblTermsOfUse: "Uslovi korišćenja",
    lblAccept: "Prihvatam",
    lblSection: "Oblast",

    //Q&A
    lblFAQ: "Najčešće postavljena pitanja",
    q1: "Kako da promenim jezik na platformi?",
    q2: "Šta ako sam zaboravio/la lozinku za pristup platformi?",
    q3: "Kako da pokrenem oblast?",
    q4: "Da li mogu da preskačem videe u okviru treninga?",
    q5: "Da li mogu da se vratim na lekciju koju sam pogledao/la da se podsetim gradiva?",
    q6: "Kako da preuzmem dokumente nakon završene oblasti?",
    q7: "Kako da se ulogujem na platformu?",
    a1: "Jezik na platformi se menja klikom na zastavu.",
    a2: "Da biste resetovali lozinku za pristup platformi, potrebno je da unesete Vašu mail adresu, i na mail će Vam biti poslata nova lozinka za pristup platformi.",
    a3: "oblast pokrećete klikom na dugme „Započnite“ u okviru početne ili info stranice oblasti.",
    a4: "Niste u mogućnosti da preskaćete videe u toku treninga.",
    a5: "Možete da ponovo da pustite lekciju koju ste pogledali.",
    a6: "Dokumente možete da preuzmete iz profila ili sa info stranice treninga.",
    a7: "Na platformu se logujete uneseći vaše korisničko ime, odnosno email adresu i lozinku koja vam je poslata na mail.",
    pauseButton: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/srp%20peach%20pause.png?alt=media&token=295e702d-6495-45ae-9b4b-669889725787",
    lblOr: "ILI",
    lblEmailVerified: "Uspešno ste verifikovali Vašu e-mail adresu. Redirektujte se na našu stranu: ",
    lblControlQuestion: "Kontrolno pitanje",
    lblAdminDocs: "Admin dokumenti",
    lblTrainingDocs: "Trening dokumenti",
    lblAdditionalDocs: "Dodatni dokumenti",
    emsLogo: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/ems%20logo%20latinica.png?alt=media&token=4beb6204-c9e6-4ff0-acd7-16c9c9d87dd0",
    lblSearch: "Pretraga",
    lblWrongFormat: "Pogrešan format.",
    lblSupportedFormatsImage: "Podržani formati su: jpg, jpeg, png",
    lblSupportedFormatsDocument: "Podržani formati su: docx, pdf i xlsx",
    lblMaxFileSizeImage:"Maksimalna veličina slike je 5MB",
    lblCalendar: "Kalendar",
    lblPreviousM: "Prethodni",
    lblPreviousTask: "Prethodni zadatak",
    lblNextM: "Sledeći",
    lblToday: "Danas",
    lblAddEvent: "Dodaj događaj",
    lblEventTitle: "Naslov događaja",
    lblDescription: "Opis",
    lblDate: "Datum",
    lblEditEvent: "Izmeni događaj",
    lblEventEdites: "Uspešno ste izmenili događaj!",
    lblEventDeleted: "Uspešno ste obrisali događaj!",
    lblEventAdded: "Uspešno ste dodali događaj!",
    lblPasswordFieldError: "Nova i potvrdjena lozinka moraju biti iste",
    lblMeetings: "Zoom sastanci",
    lblSkip: "Preskoči test",
    lblUserUnavailable: "Korisnik je zauzet.",
    lblCalling: "zove...",
    lblBackToLogin: "Nazad na prijavu",
    lblRememberMe: "Zapamti me",
    lblRequestAReset: "Zatraži reset",
    lblLearning: "Učenje",
    lblSinergy: "Sinergija",
    lblTechnology: "Tehnologija",
    lblSkip1: "Preskoči",
    lblNext1: "Dalje",
    lblStartSurvey: "Započnite zadatak",
    lblGoBackToSurvey: "Vratite se na zadatak",
    lblStartPretest: "Započnite pretest",
    lblQuestionCapsLock: "PITANJE",
    lblOfCL: "OD",
    lblDidYouFinishedTask: "Da li ste završili zadatak?",
    lblRangList: "Rang lista",
    lblTrainings: "Oblasti",
    lblFolders: "Folderi",
    lblChatRoom: "Chat soba",
    lblAiChat: "Razgovaraj sa RGZ AI",
    lblProfile: "Profil",
    lblFinishedTrainings: "Završene oblasti",
    lblSuccessfullyCompletedTraining: "Uspešno ste završili oblast",
    lblTestTimeUp: "Isteklo je predviđeno vreme za test. U obavezi ste da ponovo preslušate kompletan materijal iz ove oblasti.",
    lblEditProfile: "Izmeni profil",
    lblChangePassword: "Promeni lozinku",
    lblAllfieldsError: "Morate popuniti sva polja kako biste nastavili.",
    lblLangChange: "Promena jezika",
    lblTrainingAuthor: "Trener i autor treninga",
    lblTrainingAuthorTest: "Trener i autor testa",
    aboutProject: "О projektu",
    aboutTraining: "O oblasti",
    aboutTest: "O testu",
    lblLoadMore: "Učitaj još",
    lblJoin: "Pridruži se",
    lblFriends: "Prijatelji",
    lblAgo: "pre",
    lblDays: "dana",
    lblMonths: "meseca",
    lblTrainingStatus: "Status oblasti",
    lblTestStatus: "Status testa",
    lblTrainingName: "Naziv oblasti",
    lblTrainingDueDate: "Rok za završetak",
    lblTrainingProgres: "Progres"
  }
  labelsEng = {
    //userd-dashboard-content
    lblTraining: "Training",
    lblUnderConstruction: "This page is under construction",
    lblHomeMessageEMS: "Welcome to the EMS e-learning platform",
    lblHomeMessage: "Welcome to the e-learning platform",
    lblShowAll: "Show all",
    lblYes: "Yes",
    lblNoButton: "No",
    lblTrainingNotStarted: "Start",
    lblTrainingStarted: "Continue",
    lblTrainingFinished: "View",
    lblTrainingFinishedPopup: "You have finished this training",
    //user-profile
    lblMyCourses: "My courses",
    lblEdit: "Edit",
    lblFinished: "finished",
    lblStarted: "Started",
    lblStart: "Start",
    lblNotStarted: "not started",
    lblDateOfBirth: "date of birth",
    lblInfo: "Info",
    lblContinue: "Continue",
    lblContinueUnit: "Continue",
    lblContinueTraining: "Continue to the next training",
    lblGoBackAfterTraining: "Go back to the home page by clicking the button",
    lblSelectedImage: "Selected image",
    lblDelPicture: "Delete profile picture",
    lblDeleteThisUsersProfilePicture: "Are you sure you want to delete profile picture?",
    lblAreYouSureSurvey: "To successfully complete the training, you need to do the task.",
    lblGiveUpSurvey: "I give up on the task",
    lblAreYouSureSurvey2: "If you exit the task, you will be required to go through the entire material of this training again.",
    lblDelEvent: "Delete event",
    lblDeleteThisEvent: "Are you sure you want to delete this event?",
    lblDelete: "Delete",
    lblNo: "No, thanks",
    lblHelp: "Help",
    lblNoDocuments: "Documents are available on the KISS user support page on the RGZ intranet",
    downloadBeforeProceeding: "Download the document before proceeding to the next lesson.",
    lblDocument: "Document",
    //main-header
    lblSerbian: "Srpski",
    lblSerbianCyrillic: "Српски",
    lblEnglish: "English",
    lblLogOut: "Log out",
    lblChangeLang: "Change language",

    //training-details
    lblDuration: "Duration",
    lblOverview: "Overview",
    lblDocuments: "Documents",
    lblInstructor: "Trainer",
    lblComments: "Comments",
    lblDownload: "Download",
    lblTestResults: "Test results",
    lblSurveyResults: "task results",
    lblCertificate: "Certificate",
    lblStudents: "students",
    lblCourses: "courses",
    lblEmail: "Email",
    lblPersonResponsible: "Person responsible",
    lblSections: "Modules",
    lblStatus: "Status",
    lblProgress: "Progress",
    lblViewed: "viewed",
    lblNumOfUnits: "Lessons",
    lblNoUnits: "Currently there are no lessons for this training.",
    lblNumOfSections: "modules",
    lblduration: "duration",

    //login
    lblRedirection: "This page redirects you to the RGZ verification platform. If you are not redirected automatically, please click on this ",
    lblLanguage: "Language",
    lblLogin: "Log in",
    lblWelcomeMessage: "Welcome to the training platform of the Republic Geodetic Authority",
    lblPassword: "Password",
    lblForgotPass: "Forgot password",
    lblForgotPassEmail: "Enter your e-mail address to reset your password",
    lblPasswordChanged: "You have successfully changed your password, now you can log in.",
    lblExpiredLink: "Password reset link has expired, please request password reset again.",
    lblPasswordResetLinkSent: "Password reset link has been sent to your e-mail address.",
    lblSingIn: "Sign in",
    loginGoogle: "Sign with Google",
    loginFacebook: "Sign with facebook",
    lblDontHaveAccount: "Don't have an account?",

    lblPassRequired: "Password is required",
    lblEmailRequired: "Email is required.",
    lblGender: "Gender",
    lblMaleGender: "Male",
    lblFemaleGender: "Female",
    lblEducation: "Education",
    lblPrimaryEducation: "Primary education",
    lblSecondaryEducation: "Secondary education",
    lblHigherEducation: "Higher education",

    //registracija
    lblSignUpWrongDataMessage: "You have entered a wrong data, please check the form again or contact support.",
    lblSupport: "Support",
    lblContactSupport: "Contact support",
    lblSignUpUserAlreadyExists: "The user with entered user name or e-mail already exists, please reset your password if you have forgotten it",
    lblInvalidEmail: "Invalid email",
    lblJMBGAlreadyExists: "User with entered JMBG already exists",
    lblCaptchaFailed: "Captcha failed, please reload the page.",
    lblSignUpMessage: "Dear, you have successfully registered. Check your e-mail to log in to the platform.",
    lblSignUp: "Sign up.",
    lblJmbg: "Personal ID number",
    lblPhoneNumber: "Phone number",
    lblExpiredUser: "Dear, your deadline for completing the training has expired. For further steps, contact the DT sector.",
    lblCity: "City",

    lblEnterEmail: "If you want to reset your password, enter your e-mail address in the field",
    lblSend: "Send",
    lblAcceptTerms: "You must accept the terms of use to continue",
    lblAllFieldsCorrect: "I declare that all entered data is correct",
    lblTermsOfUse: "Terms of use",
    lblAccept: "Accept",

    //edit-profile

    lblUserName: "Username",
    lblFirstName: "First Name",
    lblLastName: "Last Name",
    lblNewPassword: "New password",
    lblEnterNewPassword: "Enter new password",
    lblConfirmPassword: "Confirm new password",
    lblSave: "Save",
    lblPasswordFieldError: "New password and confirm password must be same",

    //test
    lblNext: "Next",
    lblBack: "Back",
    lblBackToTraining: "Back to training",
    lblBackToTask: "Back to task",
    lblBackToBeginning: "Back to the beginning",
    lblGoToNextTraining: "Go to next training",
    lblSubmit: "Submit",
    lblQuestionsCompleted: "completed",
    lblStartQuiz: "Start quiz",
    //before-pre-test modal
    lblTestInFront: "In front of you is a test for checking",
    lblYourKnowledge: "your knowledge before course",
    lblTotalOf: "There is total of",
    lblQuestions: " questions.",
    lblMaxPoints: "Maximum number of points is",
    lblIfAnsweredIncorrectly: "If you answer incorrectly, you must go through the course again.",
    lblGoodLuck: "Good Luck!",
    lblTimeIsUp: "Time is up!",

    //pre-test modal
    lblYourSuccesRate: "Your success rate is",
    lblWatchAgain: 'Watch the content of this course again and take the test',
    lblYouAnswered: "You have answered correctly on",
    lblOf: "of",
    lblYouHaveWon: "You have won",
    lblPoints: "point",
    lblPointsWithA: "point",

    //before test modal
    lblTestInFront1: "In front of you is a test for checking your knowledge.",
    forPassingTheTest: "In order to pass the test",
    forPassingTheSetionTest: "In order to pass the test",
    lblMinPoints: " your success rate needs to be at least",
    lblOfferedQuestions: "offered questions.",

    //test modal
    lblYouPassed: "YOU PASSED THE TEST!",
    lblYoudDidntPassed: "YOU DIDN'T PASSED THE TEST!",
    lblYoudDidntPassedTable: "You didn't passed",
    lblCongrats: "Congratulations, you passed the test for course",
    lblSectionCongrats: "Congratulations, you passed the test for module",
    lblUnsuccessfulTestMessage: "Please try again. Without passing the test you can't finish the course.",
    lblHomePage: "Home Page",
    lblTryAgain: "Try again",

    //before survey modal
    lblSurveyIsContained: "In front of you is a task that you need to do to successfully complete the course.",
    lblSurveyIsContainedPlural: "In front of you are tasks that you need to do to successfully complete the course.",
    lblYourOpinion: "Your opinion is very important to us",
    lblInOrderToKnow: "in order to know in which way we can",
    lblToImprove: "improve user expirience on the platform",

    // survey modal
    lblThankYouforFilling: "Thank you for making time to fill the task",
    lblTypeYourAnswerHere: "Type your case number here",
    lblKlikomNaDugme: "By clicking on button task you can download task results",
    lblThankYou: "THANK YOU!",
    lblSurvey:"task",
    lblPreTest: "Pretest",
    lblTest: "Test",
    lblTestTable: "Test status",

    //training
    lblCompleted: "completed",
    backBtnPath: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/back%20dugme.png?alt=media&token=ab1d8b9b-7cc2-4318-a1d8-c0d30982ed6e",
    backBtnPath1: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/back%20dugme%20latinica.png?alt=media&token=bf7d3723-f805-421a-b058-592ccb84cb1f",
    playButton: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/Engl%20peach%20button.png?alt=media&token=6027664e-7bc7-4dca-81c3-bb7d15445d67",
    lblTrainingName: "eTraining name",


    //training modal
    lblNotification: "Notification",
    lblModalMessage: "To view the next lesson, you have to watch the current lesson to the end.",
    lblModalMessageDocument: "You have to download document first, then you can continue to next lession.",

    lblWrongLoginData: "Wrong username or password",
    lblUnverifiedEmail: "Your email is not verified. Please check your email.",
    lblOk: "Ok",

    lblSeveralCorrectAnswers: "This question has more than one correct answer",
    lblQuestionPoints: "Question for",
    lblDashboard: "Dashboard",
    lblUserProfile: "User profile",
    lblStatement: "Statement",

     //messages
     lblMessages: "Messages",
     lblWriteAMessage: "Write a message...",
     lblYou: "You: ",

     //notifications
     lblNotifications: "Notifications",
     lblDeleteAll: "Clear all",
     lblNoNotifications: "No new notifications",

     //user cards
    lblComment: "Write a comment...",
    lblSection: "Module",
    //welcome
    lblWelcome: "Welcome to the training",
    lblWelcomeTest: "Welcome to the test",

    lblDataChanged: "You have successfully changed the data.",
    lblUserDocuments: "User documents",
    pauseButton: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/engl%20peach%20pause.png?alt=media&token=a9ba29c5-2e10-4bfc-8f91-e85be0c729d9",

    //Q&A
    lblFAQ: "Frequently asked question",
    q1: "How do I change the language on the platform?",
    q2: "What if I forgot my platform access password?",
    q3: "How do I start training?",
    q4: "Can I skip videos during training?",
    q6: "How do I download the documents after the training?",
    a1: "The language on the platform can be changed by clicking on the flag.",
    a2: "To reset the password, you need to enter your e-mail address, and a new password will be sent to you by e-mail.",
    a3: "Start the training by clicking the Start button on the home or info page of the training.",
    a4: "You are not able to skip videos during training.",
    a6: "You can download the documents from the profile or from the training info page.",
    lblOr: "OR",
    lblEmailVerified: "Uspešno ste verifikovali Vašu e-mail adresu. Redirektujte se na našu stranu: ",
    lblControlQuestion: "Control question",
    lblAdminDocs: "Admin documents",
    lblTrainingDocs: "Training documents",
    lblAdditionalDocs: "Additional documents",
    lblSearch: "Search",
    lblWrongFormat: "Wrong format.",
    lblSupportedFormatsImage: "Supported formats are: jpg, jpeg, png",
    lblSupportedFormatsDocument: "Supported formats are: docx, pdf and xslx",
    lblMaxFileSizeImage:"Max image size is 5MB",
    lblCalendar: "Calendar",
    emsLogo: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/ems%20logo%20latinica.png?alt=media&token=4beb6204-c9e6-4ff0-acd7-16c9c9d87dd0",
    lblPreviousM: "Previous",
    lblPreviousTask: "Previous task",
    lblNextM: "Next",
    lblToday: "Today",
    lblAddEvent: "Add event",
    lblEventTitle: "Event title",
    lblDescription: "Description",
    lblDate: "Date",
    lblEditEvent: "Edit event",
    lblEventEdites: "Event edited successfully!",
    lblEventDeleted: "Event deleted successfully!",
    lblEventAdded: "Event added successfully!",
    lblMeetings: "Zoom meetings",
    lblSkip: "Skip test",
    lblUserUnavailable: "User is unavailable.",
    lblCalling: "calling...",
    lblBackToLogin: "Back to login",
    lblRememberMe: "Remember me",
    lblRequestAReset: "Request a reset",
    lblLearning: "Learning",
    lblSinergy: "Sinergy",
    lblTechnology: "Technology",
    lblSkip1: "Skip",
    lblNext1: "Next",
    lblStartSurvey: "Go back to task",
    lblGoBackToSurvey: "Go back to task",
    lblStartPretest: "Start pretest",
    lblQuestionCapsLock: "QUESTION",
    lblOfCL: "OF",
    lblDidYouFinishedTask: "Did you finish the task?",
    lblRangList: "Rang list",
    lblFolders: "Folders",
    lblTrainings: "Trainings",
    lblChatRoom: "Chat room",
    lblProfile: "Profile",
    lblAiChat: "Chat with RGZ AI",
    lblFinishedTrainings: "Finished trainings",
    lblSuccessfullyCompletedTraining: "You have successfully completed the training",
    lblTestTimeUp: "The allotted time for the test has expired. You are obliged to listen to the complete material from this area again.",
    lblEditProfile: "Edit profile",
    lblChangePassword: "Change password",
    lblAllfieldsError: "You must fill all fields in order to continue.",
    lblLangChange: "Change language",
    lblTrainingAuthor: "Trainer and training author",
    lblTrainingAuthorTest: "Trainer and test author",
    aboutProject: "About project",
    aboutTraining: "About training",
    aboutTest: "About test",
    lblLoadMore: "Load more",
    lblJoin: "Join",
    lblSectorGroup: "Sector group",
    lblFriends: "Friends",
    lblAgo: "ago",
    lblDays: "days",
    lblMonths: "months",
    lblTrainingStatus: "Training status",
    lblTestStatus: "Test status",
    lblTrainingDueDate: "Due date",
    lblTrainingProgres: "Progress"
  }

  labelsSrb2 = {
    lblTraining: "Oбласти",
    lblFAQ: "Најчешће постављена питања",
    q1: "Како да променим језик на платформи?",
    q2: "Шта ако сам заборавио/ла лозинку за приступ платформи?",
    q3: "Како да покренем области?",
    q4: "Да ли могу да прескачем видее у оквиру тренинга?",
    q5: "Да ли могу да се вратим на лекцију коју сам погледао/ла да се подсетим градива?",
    q6: "Како да преузмем документе након завршене области?",
    q7: "Како да се улогујем на платформу?",
    a1: "Језик на платформи се мења кликом на заставу.",
    a2: "Да бисте ресетовали лозинку за приступ платформи, потребно је да унесете Вашу маил адресу, и на маил ће Вам бити послата нова лозинка за приступ платформи.",
    a3: "области покрећете кликом на дугме „Започните“ у оквиру почетне или инфо странице области.",
    a4: "Нисте у могућности да прескаћете видее у току тренинга.",
    a5: "Можете да поново да пустите лекцију коју сте погледали.",
    a6: "Документе можете да преузмете из профила или са инфо странице тренинга.",
    a7: "На платформу се логујете унесећи ваше корисничко име, односно емаил адресу и лозинку која вам је послата на маил.",
    lblUnderConstruction: "Ова страна је у изради",
    lblHomeMessageEMS: "Добродошли на ЕМС платформу за електронску едукацију",
    lblHomeMessage: "Добродошли на платформу за електронску едукацију",
    lblShowAll: "Види све области",
    lblYes: "Да",
    lblNoButton: "Не",
    lblTrainingNotStarted: "Започните",
    lblTrainingStarted: "Наставите",
    lblTrainingFinished: "Погледај",
    lblTrainingFinishedPopup: "Завршили сте ову области",
    lblMyCourses: "Моји курсеви",
    lblEdit: "Измени",
    lblFinished: "Завршено",
    lblStarted: "Започетo",
    lblStart: "Започните",
    lblNotStarted: "Није започетo",
    lblDateOfBirth: "датум рођења",
    lblInfo: "Инфо",
    lblContinue: "Наставите",
    lblContinueUnit: "Наставите",
    lblContinueTraining: "Наставите на следећу област",
    lblGoBackAfterTraining: "Вратите се на почетну страну кликом на дугме",
    lblSelectedImage: "Изабрана слика",
    lblDelPicture: "Обриши профилну слику",
    lblDeleteThisUsersProfilePicture: "Да ли сте сигурни да желите да обришете профилну слику?",
    lblAreYouSureSurvey: "За успешан завршетак области неопходно је урадити задатак.",
    lblGiveUpSurvey: "Одустаните од задатка",
    lblAreYouSureSurvey2: "Уколико изађете из задатка, бићете у обавези да поново преслушате комплетан материјал из ове области.",
    lblDelEvent: "Обриши догађај",
    lblDeleteThisEvent: "Да ли сте сигурни да желите да обришете догађај?",
    lblDelete: "Обриши",
    lblNo: "Не , хвала",
    lblHelp: "Помоћ",
    lblNoDocuments: "Документи су доступни на страници за подршку корисницима КИСС на Интранету РГЗ-а.",
    lblSerbian: "Srpski",
    lblSerbianCyrillic: "Српски",
    lblEnglish: "Енглески",
    lblLogOut: "Одјави се",
    lblChangeLang: "Промени језик",
    lblDuration: "Трајање",
    lblOverview: "Преглед",
    lblDocuments: "Документа",
    lblInstructor: "Тренер",
    lblComments: "Коментари",
    lblDownload: "Преузми",
    downloadBeforeProceeding: "Преузмите документ пре него што наставитете на следећу лекцију.",
    lblTestResults: "Резултати теста",
    lblSurveyResults: "Резултати задатка",
    lblCertificate: "Сертификат",
    lblStudents: "студената",
    lblCourses: "курсева",
    lblEmail: "Е пошта",
    lblPersonResponsible: "Одговорна особа",
    lblSections: "Области",
    lblStatus: "Статус",
    lblProgress: "Прогрес",
    lblViewed: "погледано",
    lblNumOfUnits: "Лекције",
    lblNoUnits: "Тренутно нема лекција за ову области.",
    lblNumOfSections: "области",
    lblduration: "Трајање",
    lblLanguage: "Језик",
    lblLogin: "ПРИЈАВА",
    lblWelcomeMessage: "Добродошли на платформу за едукацију запослених у Републичком геодетском заводу",
    lblPassword: "Лозинка",
    lblForgotPass: "Заборављена лозинка",
    lblForgotPassEmail: "Унесите вашу е-маил адресу да бисте ресетовали лозинку",
    lblPasswordChanged: "Успешно стe променили лозинку, сада се можете улоговати.",
    lblExpiredLink: "Линк за ресетовање лозинке је истекао, молимо поново затражите ресетовање лозинке.",
    lblPasswordResetLinkSent: "Линк за ресетовање лозинке је послат на вашу е-маил адресу.",
    lblSingIn: "Улогуј сe",
    loginGoogle: "Пријавите се преко Google налога",
    loginFacebook: "Пријавите се преко Facebook налога",
    lblDontHaveAccount: "Немате налог?",
    lblSignUp: "Региструјте сe.",
    lblPassRequired: "Лозинка је обавезна.",
    lblEmailRequired: "Емаил је обавезан.",
    lblSignUpWrongDataMessage: "Унели сте неважеће податке, проверите поново форму или контактирајте подршку.",
    lblSupport: "Подршка",
    lblContactSupport: "Контактирајте подршку",
    lblSignUpUserAlreadyExists: "Корисник са овим корисничким именом/е-мејлом већ постоји, молимо да ресетујете лозинку уколико сте је заборавили",
    lblInvalidEmail: "Неисправан е-маил",
    lblJMBGAlreadyExists: "Корисник са унетим ЈМБГ већ постоји",
    lblCaptchaFailed: "Капча није успешна, молимо поново учитајте страницу.",
    lblSignUpMessage: "Поштовани, успешно сте се регистровали. Проверите своју е-пошту да бисте се улоговали на платформу.",
    lblJmbg: "ЈМБГ",
    lblPhoneNumber: "Број телефона",
    lblExpiredUser: "Поштовани/поштована, Ваш рок за завршетак обуке је истекао. За даље кораке, контактирајте Сектор за ДТ.",
    lblCity: "Град",
    lblEnterEmail: "Уколико желите да ресетујете лозинку у поље упишите е-маил адресу",
    lblSend: "Пошаљи",
    lblAcceptTerms: "Да бисте наставили морате да прихватите услове коришћења",
    lblAllFieldsCorrect: "Декларишем да су сви унети подаци исправни",
    lblUserName: "Корисничко име",
    lblFirstName: "Име",
    lblLastName: "Презиме",
    lblNewPassword: "Нова лозинка",
    lblEnterNewPassword: "Унесите нову лозинку",
    lblConfirmPassword: "Потврди нову лозинку",
    lblSave: "Сачувај",
    lblNext: "Наставите",
    lblBack: "Назад",
    lblBackToTraining: "Назад на област",
    lblBackToTask: "Вратите се на задатак",
    lblBackToBeginning: "Вратите се на почетак",
    lblGoToNextTraining: "Наставите на следећу област",
    lblSubmit: "Потврди",
    lblQuestionsCompleted: "завршено",
     lblTestInFront: "Пред вама је пре-тест којим меримо",
    lblYourKnowledge: "ваше зање пре области.",
    lblTotalOf: " Имате укупно",
    lblQuestions: "питања.",
    lblMaxPoints: "Максималан број бодова је",
    lblGoodLuck: "Срећно!",
    lblIfAnsweredIncorrectly: "Уколико не одговорите тачно на најмање",
    lblIfAnsweredIncorrectly2: "питања бићете у обавези да поново преслушате комплетан материјал из ове области.",
    lblTimeIsUp: "Време је истекло!",
    lblYourSuccesRate: "Ваш проценат je",
    lblWatchAgain: 'Погледајте садржај ове области поново и приступите тесту.',
    lblYouAnswered: "Одговорили сте тачно на",
    lblOf: "од",
    lblYouHaveWon: "Освојили сте укупно",
    lblPoints: "поен",
    lblPointsWithA: "поен",
    lblTestInFront1: "Пред Вама је тест за проверу знања.",
    forPassingTheTest: "За успешно полагање теста",
    forPassingTheSetionTest: "За успешно полагање теста",
    lblMinPoints: "неопходно је да одговорите тачно на",
    lblOfferedQuestions: "понуђених питања.",
    lblYouPassed: "ПОЛОЖИЛИ СТЕ!",
    lblYoudDidntPassed: "НИСТЕ ПОЛОЖИЛИ!",
    lblYoudDidntPassedTable: "Нисте положили",
    lblCongrats: "Честитамо положили сте тест за област",
    lblSectionCongrats: "Честитамо положили сте тест за област",
    lblUnsuccessfulTestMessage: "Морате поново да прођете основну области, o чијем датуму ћете бити благовремено обавештени.",
    lblHomePage: "Почетна",
    lblTryAgain: "Покушај поново",
    lblSurveyIsContained: "Пред Вама је задатак који је потребно урадити да бисте успешно завршили област.",
    lblSurveyIsContainedPlural: "Пред Вама су задаци које је потребно урадити да бисте успешно завршили област.",
    lblYourOpinion: "Ваше мишљење нам је веома важно",
    lblInOrderToKnow: "како би знали на који начин ",
    lblToImprove: "да унапредимо Ваше искуство на платформи",
    lblThankYouforFilling: "Честитамо положили сте област",
    lblTypeYourAnswerHere: "Унесите број предмета",
    lblKlikomNaDugme: "Кликом на дугме 'задатак' можете преузети попуњени задатак",
    lblThankYou: "ХВАЛА!",
    lblSurvey:"Задатак",
    lblPreTest: "Претест",
    lblTest: "Тест",
    lblTestTable: "Статус провере",
    lblCompleted: "одгледано",
    backBtnPath: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/Nazad%20dugme%20cirilica.png?alt=media&token=c1d894f3-f916-4edc-a683-fc81a575b971",
    backBtnPath1: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/Nazad%20dugme%20cirilica.png?alt=media&token=60b7a91b-1527-4a55-b797-030c4d9284ee",
    playButton: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/cirilica%20peach%20bez%20bg.png?alt=media&token=294b2d71-5100-4603-b5f2-0d97fa5cf3a4",
    lblNotification: "Обавештење",
    lblModalMessage: "Да бисте прешли на следећу лекцију морате погледати тренутну до краја.",
    lblModalMessageDocument: "Морате да преузмете документ, како бисте наставили на следећу лекцију.",
    lblWrongLoginData: "Погрешно сте унели корисничко име или лозинку.",
    lblUnverifiedEmail: "Ваша е-маил адреса није верификована. Молимо проверите своју е-маил адресу.",
    lblSeveralCorrectAnswers: "Ово питање има више тачних одговора.",
    lblQuestionPoints: "Питање носи",
    lblOk: "У реду",
    lblDashboard: "Почетна страна",
    lblUserProfile: "Профил",
    lblStatement: "Изјава",
    lblMessages: "Поруке",
    lblWriteAMessage: "Напишите поруку...",
    lblYou: "Ви: ",
    lblNotifications: "Обавештења",
    lblDeleteAll: "Обриши све",
    lblNoNotifications: "Немате ниједно обавештење",
    lblComment: "Напишите коментар...",
    lblWelcome: "Добродошли на електронску област",
    lblWelcomeTest: "Добродошли на тест",
    lblDataChanged: "Успешно сте изменили податке.",
    lblUserDocuments: "Корисничка документа",
    lblTermsOfUse: "Услови коришћења",
    lblAccept: "Прихватам",
    lblSection: "Област",
    pauseButton: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/srp%20peach%20pause.png?alt=media&token=295e702d-6495-45ae-9b4b-669889725787",
    lblOr: "ИЛИ",
    lblControlQuestion: "Kontrolno pitanje",
    lblDocument: "Документ",
    lblAdminDocs: "Админ документи",
    lblTrainingDocs: "Тренинг документи",
    lblAdditionalDocs: "Додатни документи",
    lblSearch: "Претрага",
    lblWrongFormat: "Погрешан формат.",
    lblSupportedFormatsImage: "Подржани формати су: jpg, jpeg, png",
    lblSupportedFormatsDocument: "Подржани формати су: docx, pdf и xslx",
    lblMaxFileSizeImage:"Максимална целичина слике je 5MB",
    lblCalendar: "Календар",
    emsLogo: "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/ems%20logo%20cirilica.png?alt=media&token=356e2280-14d9-47d9-a926-9fbf6e230985",
    lblPreviousM: "Претходни",
    lblPreviousTask: "Претходни задатак",
    lblNextM: "Следећи",
    lblToday: "Данас",
    lblAddEvent: "Додај догађај",
    lblEventTitle: "Наслов догађаја",
    lblDescription: "Опис",
    lblDate: "Датум",
    lblEditEvent: "Измени догађај",
    lblEventEdites: "Успешно сте изменили догађај!",
    lblEventDeleted: "Успешно сте обрисали догађај!",
    lblEventAdded: "Успешно сте додали догађај!",
    lblPasswordFieldError: "Нова и потврђена лозинка морају бити исте",
    lblMeetings: "Zoom sастанци",
    lblTrainingName: "Назив области",
    lblSkip: "Прескочи тест",
    lblUserUnavailable: "Корисник је заузет",
    lblCalling: "зове...",
    lblRedirection: "Ова страница вас преусмерава на платформу за верификацију RGZ. Уколико нисте преусмерени аутоматски, молимо кликните на ",
    lblBackToLogin: "Назад на пријаву",
    lblRememberMe: "Запамти ме",
    lblRequestAReset: "Затражи ресет",
    lblLearning: "Учење",
    lblSinergy: "Синергија",
    lblTechnology: "Технологија",
    lblSkip1: "Прескочи",
    lblNext1: "Даље",
    lblStartQuiz: "Започните тест",
    lblStartSurvey: "Започните задатак",
    lblGoBackToSurvey: "Вратите се на задатак",
    lblStartPretest: "Започните претест",
    lblQuestionCapsLock: "ПИТАЊЕ",
    lblOfCL: "ОД",
    lblDidYouFinishedTask: "Да ли сте завршили задатак?",
    lblRangList: "Ранг листа",
    lblTrainings: "Oбласти",
    lblFolders: "Фолдери",
    lblChatRoom: "Чет соба",
    lblProfile: "Профил",
    lblAiChat: "Разговарај са РГЗ АИ",
    lblFinishedTrainings: "Завршене области",
    lblSuccessfullyCompletedTraining: "Успешно сте завршили област",
    lblTestTimeUp: "Истекло је предвиђено време за тест. У обавези сте да поново преслушате комплетан материјал из ове области.",
    lblEditProfile: "Измени профил",
    lblChangePassword: "Промени лозинку",
    lblAllfieldsError: "Морате попунити сва поља како бисте наставили.",
    lblLangChange: "Промена језика",
    lblTrainingAuthor: "Тренер и аутор тренинга",
    lblTrainingAuthorTest: "Тренер и аутор теста",
    aboutProject: "О пројекту",
    aboutTraining: "О области",
    aboutTest: "О тесту",
    lblLoadMore: "Учитај још",
    lblJoin: "Придружи се",
    lblSectorGroup: "Сектор група",
    lblFriends: "Пријатељи",
    lblAgo: "пре",
    lblDays: "дана",
    lblMonths: "месеца",
    lblTrainingStatus: "Статус области",
    lblTestStatus: "Статус теста",
    lblTrainingDueDate: "Рок за завршетак:",
    lblTrainingProgres: "Прогрес:"
  }
}
